import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FurXObraPublica } from 'src/app/models/FurXObraPublica';
import { NavModalComponent } from '../../General/nav-modal/nav-modal.component';
import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { DscTituloPaginator, ngClassAceptarModal, ngClassSalirModal, recupToolTipCar, StrDscToolTipText, strMatTablePaginator } from 'src/app/general/variables';
import { FichaXContratacion } from 'src/app/models/FichaXContratacion';
import { General } from 'src/app/models/General';

@Component({
  selector: 'app-modal-hecho-irregular',
  templateUrl: './modal-hecho-irregular.component.html',
  styleUrls: ['./modal-hecho-irregular.component.css']
})
export class ModalHechoIrregularComponent implements OnInit {

  strDscHi = '';
  flgViewDscHi = false;
  flgDeshabilitado = true;
  flgObra = false;
  flgContratacion = false;
  listaHechoIrregular: General[] = [];

  matTableColumnsDef = ['Item', 'Hecho Irregular'];
  matTableColumnsEtiq = ['Ítem', 'Tema del presunto hecho irregular'];
  strMatTablePaginator = strMatTablePaginator;
  obra: FurXObraPublica;
  contratacion: FichaXContratacion;
  ngClassAceptarModal = ngClassAceptarModal;
  ngClassSalirModal = ngClassSalirModal;

  strDscTooltip: string = StrDscToolTipText;

  dataSource: MatTableDataSource<General>;

  @ViewChild(NavModalComponent) navModalC: NavModalComponent;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  constructor(private dialogRef: MatDialogRef<ModalHechoIrregularComponent>, @Inject(MAT_DIALOG_DATA) public data: any, ) { }


  ngOnInit() {

    // var vFurXObraPublicaXHi:FurXObraPublicaXHi = null;
    let vItem = null;
    let vListaInput = null;


    this.obra = this.data.obra;
    this.contratacion = this.data.contratacion;

    this.navModalC.setDatosNavModal2('Materia del hecho irregular');

    if (this.paginator != null) {this.paginator._intl.itemsPerPageLabel = DscTituloPaginator; } // this.paginator._intl.itemsPerPageLabel = DscTituloPaginator;

    if (this.obra != null) {

      vListaInput = this.obra.listaFurPorObraPubPorHechoIrr;

      vItem = vListaInput.filter(x => x.cfurxobpxhiFlgnuevo == 'SI')[0];
      this.flgObra = true;

    } else if (this.contratacion != null) {

      vListaInput = this.contratacion.listaFichaPorContratacionPorHechoIrregular;

      vItem = vListaInput.filter(x => x.cfichaxcontxhiFlgnuevo == 'SI')[0];
      this.flgContratacion = true;

    }

    if (vItem != null) {

      this.flgViewDscHi = true;

      this.strDscHi = this.flgObra ? vItem.cfurxobpxhiDschi : vItem.cfichaxcontxhiDschi;

    } else {

      this._cargarListadoHi(vListaInput, (this.flgObra ? 'cfurxobpxhiDschi' : 'cfichaxcontxhiDschi'));

    }

    this._cargarTableMaterial();

  }

  _cambioDescripcion() {

    this.strDscTooltip = recupToolTipCar(this.strDscHi);


  }

  _cargarListadoHi(lista: any, strDscCampo: string) {

    let vGeneralItem: General = null;

    lista.forEach(element => {

      vGeneralItem = new General();

      vGeneralItem.dscCampo1 = element[strDscCampo];

      this.listaHechoIrregular.push(vGeneralItem);

    });

  }

  _aceptarModal() {



    this._cerrarModal();

  }

  _cerrarModal() {

    this.dialogRef.close();

  }

  _cargarTableMaterial() {

    // this.dataSource = new MatTableDataSource(this.obra.listaFurPorObraPubPorHechoIrr);
    this.dataSource = new MatTableDataSource(this.listaHechoIrregular);
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;

  }

}
